import { Box, IconButton, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import React, { useState } from 'react';
import AddNotesPopup from './AddNotesPopup';
import EditIcon from '@mui/icons-material/Edit';

export default function NotesSection({ notes, onDelete, onEdit, readOnly = false }) {
  const [notesPopupOpen, setNotesPopupOpen] = useState(false);

  const handleOpen = () => {
    setNotesPopupOpen(true);
  };

  const handleClose = () => {
    setNotesPopupOpen(false);
  };
  return (
    <>
      {notes && (
        <Box
          sx={{
            border: '1px solid #e0e0e0',
            borderRadius: '8px',
            padding: 1.5,
          }}
        >
          <Typography sx={{ whiteSpace: 'pre-line' }}>
            <Typography component="span" fontWeight="bold">
              Notes
            </Typography>
            {!readOnly && (
              <IconButton aria-label="edit" color="primary" onClick={handleOpen} sx={{ pr: 0, ml: 2 }}>
                <EditIcon fontSize="small" />
              </IconButton>
            )}
            {!readOnly && (
              <IconButton aria-label="delete" color="error" onClick={onDelete}>
                <DeleteIcon fontSize="small" />
              </IconButton>
            )}
            {'\n'}
            {notes}
          </Typography>
        </Box>
      )}
      <AddNotesPopup open={notesPopupOpen} onClose={handleClose} addNotes={onEdit} initialData={{ notes }} />
    </>
  );
}
